export default class RepresentanteParte {
    genero;
    nome;
    numRepresentante;
    regOAB = {
        numero: '',
        tipo: '',
        siglaUf: ''
    };

    inscricoes;
}

export class InscricaoRepresentanteParte {
    idInscricao;
    sessaoId;
    numeroCompletoProcesso;

    sequencialApreciacaoProcesso;

    denominacaoDaParte;
    nomeDaParte;
    codigoDaParte;

    dataSolicitacaoSustentacao;
    fasePreferencialSustentacao;
    modoParticipacao;
    preferencia;
    presente;
    sequencialPreferencia;
    sustentacaoOral;
}
